enum EquipmentStates {
    UnderConstruction = 'underConstruction',
    InUse = 'inUse',
    InMaintenance = 'inMaintenance',
    OutOfService = 'outOfService',
    Deleted = 'deleted',
}

export { EquipmentStates };
